import { amountScale, isNegativeMoney, negateMoney, trimRate } from '@familywallet/shared';

/** Display formatting lives in packages/shared so the server-side PDF formats money the same way. */
export { formatAmount } from '@familywallet/shared';

/** "89500.0000000000" -> "89,500": a rate as people say it (1 USD = 89,500 LBP). */
export function formatRateValue(rate: string, locale?: string): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 10 }).format(
    trimRate(rate) as Intl.StringNumericLiteral,
  );
}

/** A card's balance is negative while money is owed; people read it as "owes 40". */
export function owedAmount(balance: string): string | null {
  return isNegativeMoney(balance) ? negateMoney(balance) : null;
}

/** "LBP" -> "Lebanese Pound" in the screen's language (falls back to the code). */
export function currencyName(code: string, locale?: string): string {
  try {
    return new Intl.DisplayNames(locale, { type: 'currency' }).of(code) ?? code;
  } catch {
    return code;
  }
}

/**
 * An amount written back into an input with thousand separators ("1500000" -> "1,500,000",
 * "12.5" USD -> "12.50"). Always en-US separators, which parseAmountInput reads back exactly:
 * a dot makes commas thousand separators, and whole-number currencies never have decimals.
 */
export function groupAmountInput(amount: string, currency: string): string {
  const whole = amountScale(currency) === 0;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 4,
  }).format(amount as Intl.StringNumericLiteral);
}
